const config = {
    onUpdate: (registration)=>{
        // Töröljük az összes cache-t
        caches.keys().then(cacheNames => {
            cacheNames.forEach(cacheName => {
              caches.delete(cacheName);
            });
        });

        // Ha van várakozó service worker, aktiváljuk
        if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        // Újratöltjük az oldalt amikor az új SW aktiválódott
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!refreshing) {
                refreshing = true;
                window.location.reload();
            }
        });
    }
};

export default config;